const params = new URLSearchParams(window.location.search);

// Define store domains by country
const storeByCountry = {
  MY: "https://ttracing.my",
  SG: "https://ttracing.sg",
  AU: "https://ttracing.com.au",
  PH: "https://ttracing.ph",
  TH: "https://ttracing.co.th",
  ID: "https://ttracing.co.id",
  UK: "https://ttracing.uk"
};

// Define paths by keyword
const pageByKeyword = {
  nox: "/products/ttracing-nox-monitor-arm",
  naruto: "/pages/naruto-shippuden-edition",
  marvel: "/pages/marvel",
  starwars: "/pages/star-wars",
  starwarsguardianfloorpad: "/products/ttracing-guardian-gaming-floorpad-star-wars-edition",
  starwarsdaxmat: "/products/ttracing-dax-mat-star-wars-edition",
  venom: "/pages/maxx-venom-edition",
  grogu: "/pages/duo-v4-grogu-edition",
  deadpoolwolverine: "/pages/deadpool-wolverine",
  titus: "/pages/titus-smart-standing-desk",
  mandalorian: "/pages/surge-x-mandalorian-edition",
  darthvader: "/pages/darth-vader-edition",
  spiderman: "/pages/duo-v4-pro-spider-man-edition",
  blackpanther: "/pages/swift-x-black-panther-edition",
  captainamerica: "/pages/surge-x-captain-america-edition",
  antman: "/pages/swift-x-2020-ant-man-edition",
  hulk: "/pages/swift-x-pro-hulk-edition",
  drstrange: "/pages/dr-strange-edition",
  arcus: "/products/ttracing-arcus-monitor-arm",
  fantastic4: "/pages/fantastic-4",
  fantastic4floorpad: "/products/ttracing-guardian-gaming-floorpad-fantastic-4-edition",
  ironman: "/pages/iron-man-edition",
  marvelfloorpad: "/products/ttracing-guardian-gaming-floorpad-marvel-edition",
  starwarsfloorpad: "/products/ttracing-guardian-gaming-floorpad-star-wars-collectors-edition",
  stormtrooper: "/pages/duo-v4-stormtrooper-edition",
  akatsuki: "/pages/akatsuki",
  onepiece: "/pages/one-piece",
  tivon: "/pages/tivon-smart-standing-desk"
};

// Find which keyword exists in query params
let keyword = null;
for (const key of Object.keys(pageByKeyword)) {
  if (params.has(key)) {
    keyword = key;
    break;
  }
}

if (keyword) {
  fetch("https://ipapi.co/json/")
    .then((res) => res.json())
    .then((data) => {
      const country = data.country_code;
      console.log("Visitor country:", country);

      if (storeByCountry[country]) {
        const target = storeByCountry[country] + pageByKeyword[keyword];
        window.location.replace(target);
      }
    })
    .catch((err) => console.error("Geolocation error:", err));
}
